import { PageHeaderWithRichIcon } from '@components/page-header-with-rich-icon/page-header-with-rich-icon';
import { RichIconTypes } from '@eika/rich-icon';
import { useTranslation } from '@translations';

export const Header = () => {
    const { processSummary } = useTranslation();

    return (
        <PageHeaderWithRichIcon
            header={processSummary.header}
            richIconType={RichIconTypes.FORELDREKONTROLL_OEKONOMISK_VEILEDER_KUNNSKAP}
        />
    );
};
